/**
 * Created by Florin David on 30/06/2020.
 */

import Action, { SET_OFFLINE } from 'constants/action-types'

/**
 * Generic errors
 */
export default (state = false, action: Action): boolean => {
  switch (action.type) {
    case SET_OFFLINE:
      return action.payload
    default:
      return state
  }
}
